import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from) {
    // 只在路由路径变化时滚动到顶部，query 参数变化时不滚动
    if (to.path !== from.path) {
      return { top: 0 }
    }
    // 如果路径相同（只是 query 参数变化），保持当前滚动位置
    return false
  },
  routes: [
    {
      path: '/',
      component: MainLayout,
      redirect: '/problems',
      children: [
        {
          path: '',
          name: 'home',
          redirect: '/problems'
        },
        {
          path: 'problems',
          name: 'problems',
          component: () => import('../views/problem/ProblemList.vue')
        },

        {
          path: 'contests',
          name: 'contests',
          component: () => import('../views/contest/ContestList.vue')
        },
        {
          path: 'contests/:id',
          name: 'contestDetail',
          component: () => import('../views/contest/ContestDetail.vue')
        },
        {
          path: 'courses',
          name: 'courses',
          component: () => import('../views/course/Index.vue')
        },
        {
          path: 'courses/:id',
          name: 'courseDetail',
          component: () => import('../views/course/CourseDetail.vue')
        },
        {
          path: 'courses/:id/learn',
          name: 'coursePlayer',
          component: () => import('../views/course/CoursePlayer.vue')
        },
        {
          path: 'ranking',
          name: 'ranking',
          component: () => import('../views/ranking/RankingList.vue')
        },
        {
          path: 'classes',
          name: 'classes',
          component: () => import('../views/class/ClassList.vue')
        },
        {
          path: 'classes/:id',
          name: 'classDetail',
          component: () => import('../views/class/ClassDetail.vue')
        },
        {
          path: 'learning',
          name: 'learning',
          component: () => import('../views/learning/LearningTrack.vue')
        },
        {
          path: 'wrong-problems',
          name: 'wrongProblems',
          component: () => import('../views/learning/WrongProblems.vue')
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import('../views/user/Profile.vue')
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('../views/user/Feedback.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/problems/:id',
      name: 'problemDetail',
      component: () => import('../views/problem/ProblemDetail.vue')
    },
    {
      path: '/auth/login',
      name: 'login',
      component: () => import('../views/auth/Login.vue')
    },
    {
      path: '/auth/register',
      name: 'register',
      component: () => import('../views/auth/Register.vue')
    },
    {
      path: '/auth/forgot-password',
      name: 'forgotPassword',
      component: () => import('../views/auth/ForgotPassword.vue')
    },
    {
      path: '/auth/reset-password',
      name: 'resetPassword',
      component: () => import('../views/auth/ResetPassword.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('../views/error/NotFound.vue')
    },
    // Admin routes
  ]
})

export default router
